module.exports = __webpack_public_path__ + "img/video.04c27d55.png";